import APIService from './APIService'

export default class MetricsService {
  getAll (payload = []) {
    return new Promise((resolve, reject) => {
      let api = new APIService()
      api.get('lives-changed', payload).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getTotals (payload = []) {
    return new Promise((resolve, reject) => {
      let api = new APIService()
      api.get('lives-changed/totals', payload).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getExportToken () {
    return new Promise((resolve, reject) => {
      let api = new APIService()
      api.get('lives-changed/export')
        .then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
    })
  }
}
